export var INTAKE_SITE_STAGING = 'datad0g.com';
export var INTAKE_SITE_FED_STAGING = 'dd0g-gov.com';
export var INTAKE_SITE_US1 = 'datadoghq.com';
export var INTAKE_SITE_EU1 = 'datadoghq.eu';
export var INTAKE_SITE_US1_FED = 'ddog-gov.com';
export var PCI_INTAKE_HOST_US1 = 'pci.browser-intake-datadoghq.com';
export var INTAKE_URL_PARAMETERS = ['ddsource', 'ddtags'];
//# sourceMappingURL=intakeSites.js.map